import React from "react"
import { TagProps } from "../types"

const Tag: React.FC<TagProps> = ({ label, onRemove, disabled = false }) => {
  return (
    <span className="inline-flex items-center px-2 py-1 text-[1.4rem] rounded-md bg-warning bg-opacity-10 text-white mr-1 mb-1">
      <span className="truncate max-w-[200px]">{label}</span>
      {!disabled && (
        <button
          type="button"
          onClick={onRemove}
          className="ml-1 text-white focus:outline-none transition-colors duration-150"
          aria-label={`Remove ${label}`}
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
    </span>
  )
}

export default Tag
